// extracted by mini-css-extract-plugin
export default {"root":"booking_detail_category_settings-module___root___a9430769"};